/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamRevisionBotexamidLangGridQueryResponse,
  GetApiV1ExamRevisionBotexamidLangGridPathParams,
  GetApiV1ExamRevisionBotexamidLangGridQueryParams,
  GetApiV1ExamRevisionBotexamidLangGrid401,
  GetApiV1ExamRevisionBotexamidLangGrid404,
  GetApiV1ExamRevisionBotexamidLangGrid500,
} from "../../types/examRevisionController/GetApiV1ExamRevisionBotexamidLangGrid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamRevisionBotexamidLangGrid } from "../../clients/examRevisionController/getApiV1ExamRevisionBotexamidLangGrid.ts";

export const getApiV1ExamRevisionBotexamidLangGridQueryKey = (
  botExamId: GetApiV1ExamRevisionBotexamidLangGridPathParams["botExamId"],
  params?: GetApiV1ExamRevisionBotexamidLangGridQueryParams,
) =>
  [
    {
      url: "/api/v1/exam/revision/:botExamId/lang/grid",
      params: { botExamId: botExamId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamRevisionBotexamidLangGridQueryKey = ReturnType<
  typeof getApiV1ExamRevisionBotexamidLangGridQueryKey
>;

export function getApiV1ExamRevisionBotexamidLangGridQueryOptions(
  botExamId: GetApiV1ExamRevisionBotexamidLangGridPathParams["botExamId"],
  params?: GetApiV1ExamRevisionBotexamidLangGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamRevisionBotexamidLangGridQueryKey(
    botExamId,
    params,
  );
  return queryOptions<
    GetApiV1ExamRevisionBotexamidLangGridQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionBotexamidLangGrid401
      | GetApiV1ExamRevisionBotexamidLangGrid404
      | GetApiV1ExamRevisionBotexamidLangGrid500
    >,
    GetApiV1ExamRevisionBotexamidLangGridQueryResponse,
    typeof queryKey
  >({
    enabled: !!botExamId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamRevisionBotexamidLangGrid(botExamId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista paginada dos idiomas cadastrados para uma prova gerada por IA, ordenados por cultura. Cada item inclui código e nome do idioma, título, instrução, status e situação do registro. **(Requer Authorization para autenticação)**
 * @summary Listar idiomas da prova gerada por IA no grid (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/:botExamId/lang/grid}
 */
export function useGetApiV1ExamRevisionBotexamidLangGrid<
  TData = GetApiV1ExamRevisionBotexamidLangGridQueryResponse,
  TQueryData = GetApiV1ExamRevisionBotexamidLangGridQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamRevisionBotexamidLangGridQueryKey,
>(
  botExamId: GetApiV1ExamRevisionBotexamidLangGridPathParams["botExamId"],
  params?: GetApiV1ExamRevisionBotexamidLangGridQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamRevisionBotexamidLangGridQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamRevisionBotexamidLangGrid401
          | GetApiV1ExamRevisionBotexamidLangGrid404
          | GetApiV1ExamRevisionBotexamidLangGrid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamRevisionBotexamidLangGridQueryKey(botExamId, params);

  const query = useQuery(
    {
      ...getApiV1ExamRevisionBotexamidLangGridQueryOptions(
        botExamId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionBotexamidLangGrid401
      | GetApiV1ExamRevisionBotexamidLangGrid404
      | GetApiV1ExamRevisionBotexamidLangGrid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
